/** The only composer-generated selected-skills protocol accepted by the UI. */
export const MAX_SELECTED_SKILLS = 5;
const INSTRUCTION = "The user explicitly selected these skills for this turn. Consult get_skill_instructions for each selected skill before answering and use it when relevant; selection is guidance, not a mandate.";
const OPEN = '<selected_skills source="composer" version="1">';
const CLOSE = '</selected_skills>';
const escapeXml = (value: string) => value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&apos;");
const unescapeXml = (value: string) => value.replace(/&(?:amp|quot|lt|gt|apos);/g, (entity) => ({ "&amp;": "&", "&quot;": '"', "&lt;": "<", "&gt;": ">", "&apos;": "'" })[entity] ?? entity);

export function normalizeSelectedSkills(names: readonly string[]): string[] {
  return [...new Set(names.filter((name): name is string => typeof name === "string").map((name) => name.trim()).filter(Boolean))].slice(0, MAX_SELECTED_SKILLS);
}

export function serializeSelectedSkills(names: readonly string[]): string {
  const selected = normalizeSelectedSkills(names);
  if (!selected.length) return "";
  return `${OPEN}\n<instruction>${INSTRUCTION}</instruction>\n${selected.map((name) => `<skill name="${escapeXml(name)}" />`).join("\n")}\n${CLOSE}`;
}

// The exact marker, instruction and child grammar avoid consuming user-authored XML.
const BLOCK = /<selected_skills source="composer" version="1">\n<instruction>The user explicitly selected these skills for this turn\. Consult get_skill_instructions for each selected skill before answering and use it when relevant; selection is guidance, not a mandate\.<\/instruction>\n((?:<skill name="(?:[^"<&]|&(?:amp|quot|lt|gt|apos);)+" \/>\n?)+)<\/selected_skills>/g;
const SKILL = /<skill name="((?:[^"<&]|&(?:amp|quot|lt|gt|apos);)+)" \/>/g;

export function extractSelectedSkills(text: string): { skills: string[]; cleanText: string } {
  const skills: string[] = [];
  const cleanText = text.replace(BLOCK, (_block, rows: string) => {
    for (const match of rows.matchAll(SKILL)) skills.push(unescapeXml(match[1]));
    return "";
  }).replace(/^\n\n/, "");
  return { skills: normalizeSelectedSkills(skills), cleanText };
}

export function stripSelectedSkills(text: string): { text: string; skills: string[] } {
  const { cleanText, skills } = extractSelectedSkills(text);
  return { text: cleanText, skills };
}

export function prependSelectedSkills(names: readonly string[], text: string): string {
  const cleanText = extractSelectedSkills(text).cleanText;
  const block = serializeSelectedSkills(names);
  return block ? `${block}\n\n${cleanText}` : cleanText;
}
